import { Component, Input, input } from '@angular/core';

@Component({
	selector: 'app-field-label',
	standalone: true,
	imports: [],
	templateUrl: './field-label.component.html',
	styleUrl: './field-label.component.scss',
})
export class FieldLabelComponent {
	@Input('for') public for: string | undefined;
}
